<template>
  <div class="mx-auto" style="width: 80%" >

   <div v-if="!isAuthenticated"><b-spinner type="grow"></b-spinner></div>
   <h2>IAM Testuser Builder</h2>


   <b-alert show variant="danger" v-if="isUnauthorized" >
    You are not authorized to use the Testuser Builder. If you believe you should have access, please have your administrator add you to the appropriate group in grouper.
   </b-alert>
   <b-alert show v-if="showMessage" dismissible v-bind:variant="messageVariant" style="white-space: pre;">{{message}}</b-alert>

           <p v-if="isAuthorized">You are logged in as <b>{{user}}.</b></p>

    <TestuserBuilderList v-if="isAuthorized" v-bind:testusers="testusers"></TestuserBuilderList>


     

  </div>

</template>

<script>

import {FETCH_CAS_TICKET, FETCH_JWT} from '../../store/actions/auth'
import {FETCH_TEST_USERS, CREATE_TEST_USER, DELETE_TEST_USER} from '../../store/actions/testusers'
import TestuserBuilderList from './TestuserBuilderList'
  // FETCH_JWT,
  // ON_SUCCESSFUL_AUTHORIZATION,
  // NOTIFY_AUTH_FAILURE,
  // LOGOUT} 

export default {
  name: 'TestuserBuilder',
  components: {
    TestuserBuilderList
  },
  computed: {
    count() {
      return this.$store.getters.testusers
    },
    user() {
      return this.$store.getters.jwtSubject
    },
    isAuthenticated() {
      return this.$store.state.auth.authenticated
    },
    isAuthorized() {
      return this.$store.getters.isAuthorized
    },
    isUnauthorized() {
      //for explicit deny
      return (this.$store.state.auth.status === 'unauthorized') ? true : false
    },
    testusers() {
      return this.$store.getters.testusers
      // return [{uid: "asdf", cn: "asdf", umStudent: "asdf", umEmployee: "asdff", blarg: false}]
      // return this.$store.testusers
      // return this.$store.getters.testusers()
    },
    status() {
      return this.$store.state.auth.status
    },
    messageVariant() {
      return this.$store.state.testusers.message.variant
    },
    message() {
      return this.$store.state.testusers.message.text
    },
    showMessage() {
      return this.$store.state.testusers.message.text.length > 0
    }
  },

  
  created: function() {
    //states:
    // logged out
    // has cas ticket
    // authorized
    // unauthorized
    //check for cas ticket

    if(!this.$store.authenticated) {
      if(this.$route.query.ticket) {
        //we have a CAS ticket, proceed with exchange for token
        this.$store.dispatch(FETCH_JWT, this.$route.query.ticket)
          .then(() => {
            this.$router.push("/")
            return this.$store.dispatch(FETCH_TEST_USERS)
          })
          // .then(() => {
          //   this.$store.dispatch(FETCH_TEST_USERS)
          // }) TODO was this here for some reason? or just a duplicate?


      } else {
        //we need a CAS ticket, redirect to cas
        this.$store.dispatch(FETCH_CAS_TICKET)
      }

    }

  },
  props: {
    msg: String
  },
  methods: {
    createTestuser() {
      // eslint-disable-next-line no-console
      console.log(this.$store)
      this.$store.dispatch(CREATE_TEST_USER)

      // this.$store.commit('increment')
    },
    deleteAllTestusers() {
      this.$store.dispatch(DELETE_TEST_USER, this.$store.getters.testusers)
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
